module.exports = __webpack_public_path__ + "img/REC_ENFANT_HOMME_ACTIVE.0eb8fd7a.svg";